import React, { useMemo } from 'react'
import { FolderIcon } from '@heroicons/react/24/outline'
import AlbumModel from '../../models/album'
import { Autocomplete, AutocompleteOption } from '../Autocomplete'
import { useAlbumAutocomplete } from './AlbumAutocomplete.hook'

interface AlbumOption extends AutocompleteOption {
  album: AlbumModel
}

interface AlbumAutocompleteProps {
  workspaceId: string
  value?: AlbumModel
  onChange: (album: AlbumModel | undefined) => void
  disabled?: boolean
  placeholder?: string
}

export const AlbumAutocomplete: React.FC<AlbumAutocompleteProps> = ({
  workspaceId,
  value,
  onChange,
  disabled = false,
  placeholder = 'Wybierz album...',
}) => {
  const { query, setQuery, options, loading } = useAlbumAutocomplete(workspaceId)

  const emptyMessage = query.trim()
    ? `Brak pasujących albumów`
    : 'Zacznij pisać, aby wyszukać album'

  const mappedOptions: AlbumOption[] = useMemo(
    () => options.map((a) => ({ id: a.id, label: a.name, album: a })),
    [options]
  )

  const mappedValue: AlbumOption | undefined = value
    ? { id: value.id, label: value.name, album: value }
    : undefined

  return (
    <Autocomplete<AlbumOption>
      options={mappedOptions}
      value={mappedValue}
      onChange={(opt) => onChange(opt?.album)}
      onQueryChange={setQuery}
      loading={loading}
      disabled={disabled}
      placeholder={placeholder}
      icon={<FolderIcon className={`h-4 w-4 ${value ? 'text-indigo-500' : 'text-gray-400'}`} />}
      emptyMessage={emptyMessage}
      clearable
      tintColor={value ? '#6366f1' : undefined}
    />
  )
}
